import { useNavigate } from "react-router-dom";
import errorImage from "@/assets/images/error-404.png";

type ErrorFallbackProps = {
  type?: "network" | "not-found";
};

const ErrorFallback = ({ type = "network" }: ErrorFallbackProps) => {
  const navigate = useNavigate();
  const isLoggedIn = Boolean(localStorage.getItem("accessToken"));

  const handleAction = () => {
    if (type === "network") {
      window.location.reload();
    } else {
      navigate(isLoggedIn ? "/" : "/login");
    }
  };

  return (
    <div className='min-h-screen flex flex-col items-center justify-center bg-white px-6 py-12 text-center space-y-8'>
      <img src={errorImage} alt='404 Error' className='max-w-xs w-64 mx-auto' />
      <h2 className='text-2xl font-bold text-gray-900'>
        {type === "network"
          ? "فشل في التحميل، حاول مرة أخرى"
          : "الصفحة غير موجودة"}
      </h2>
      <p className='text-gray-700 text-base max-w-md mx-auto'>
        {type === "network"
          ? "حدث خطأ أثناء الحصول على البيانات الخاصة بك، اضغط على إعادة تحميل الصفحة لتحميلها مرة أخرى."
          : "الصفحة التي تحاول الوصول إليها غير متوفرة، قد تكون أدخلت رابطًا خاطئًا أو الصفحة تم نقلها."}
      </p>
      <button
        onClick={handleAction}
        className='bg-red-700 hover:bg-red-800 text-white font-bold text-lg py-3 px-8 rounded-xl transition-all'
      >
        {type === "network"
          ? "إعادة تحميل الصفحة"
          : isLoggedIn
          ? "الرجوع إلى الصفحة الرئيسية"
          : "الذهاب لتسجيل الدخول"}
      </button>
    </div>
  );
};

export default ErrorFallback;
